angular.module('bribac.components.insuranceDetails', [
  'bribac.translations',
  'bribac.values'
])

  .component('insuranceDetails', {
    templateUrl: 'insurance-details-component.html',
    controller: 'InsuranceDetailsCtrl',
    bindings: {
      insurance: '<'
    }
  })

  .controller('InsuranceDetailsCtrl', function(
    permissions,
    state
  ) {
    var $ctrl = this
    $ctrl.permissions = permissions
    $ctrl.state = state
  })
